import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { ProductService } from 'src/app/service/product.service';
import { ConfirmaDeleteComponent } from 'src/app/util/confirma-delete/confirma-delete.component';
import { aplicarFiltrosConsulta, isFiltroIdNumerico } from 'src/app/util/consulta/wow-consulta.util';
import { Product } from './product';

@Component({
  selector: 'app-product-consulta',
  templateUrl: './product-consulta.component.html',
  styleUrls: [
    './product.component.scss',
    '../../util/conta-financeira/conta-financeira-consulta.scss',
  ],
})
export class ProductConsultaComponent {

  products: Product[] = [];
  ordemColunasTabela = ['id', 'name', 'price', 'pricePort', 'stockQuantity', 'active', 'excluir', 'editar'];
  totalElementos = 0;
  pagina = 0;
  tamanho = 5;
  pageSizeOptions: number[] = [5, 10, 15, 100];
  mensagemErros: String[] = [];
  consultaRealizada = false;
  tipoFiltros = ['ID', 'Nome'];
  tipoFiltro = 'ID';
  parametro = '';
  situacao: boolean | null = null;

  constructor(
    private productService: ProductService,
    private snackBar: MatSnackBar,
    public dialog: MatDialog,
    private router: Router,
  ) { }

  novo() {
    this.router.navigate(['/product/form']);
  }

  editar(id: number) {
    this.router.navigate(['/product/form', id]);
  }

  consultar(resetPagina = true) {
    if (resetPagina) this.pagina = 0;
    const idFiltro = isFiltroIdNumerico(this.tipoFiltro, this.parametro);
    if (idFiltro != null) {
      this.productService.findProductById(idFiltro).subscribe(item => {
        let lista = [item];
        lista = aplicarFiltrosConsulta(lista, this.tipoFiltro, this.parametro, this.situacao, {
          id: p => p.id,
          nome: p => p.name,
          ativo: p => p.active === true || p.active === 'true',
        });
        this.products = lista;
        this.totalElementos = lista.length;
        this.consultaRealizada = true;
      }, err => this.mensagemErros = ['Erro: ' + (err.error?.message ?? 'Produto não encontrado')]);
      return;
    }
    this.productService.list(this.pagina, this.tamanho).subscribe((response) => {
      const filtrados = aplicarFiltrosConsulta(response.content ?? [], this.tipoFiltro, this.parametro, this.situacao, {
        id: p => p.id,
        nome: p => p.name,
        ativo: p => p.active === true || p.active === 'true',
      });
      this.products = filtrados;
      this.totalElementos = (this.parametro || this.situacao !== null) ? filtrados.length : response.totalElements;
      this.pagina = response.number;
      this.consultaRealizada = true;
      this.mensagemErros = [];
    }, err => {
      this.mensagemErros = ['Erro: ' + (err.error?.message ?? 'Falha ao consultar produtos')];
    });
  }

  paginar(event: PageEvent) {
    if (!this.consultaRealizada) {
      return;
    }
    this.pagina = event.pageIndex;
    this.tamanho = event.pageSize;
    this.consultar(false);
  }

  openDialog(id: number) {
    const dialogRef = this.dialog.open(ConfirmaDeleteComponent);
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.excluir(id);
      }
    });
  }

  private excluir(id: number) {
    this.productService.delete(id).subscribe(() => {
      this.mensagemErros = [];
      this.snackBar.open('Produto excluído com sucesso!', 'Sucesso', { duration: 2000 });
      this.consultar(false);
    }, errorResponse => {
      this.mensagemErros = ['Erro: ' + errorResponse.error.message];
    });
  }
}
